import axios from 'src/utils/axios';

export default function v2_actionListarListas(clienteId) {
    return axios.get(`/api/v2/cadastro/contatos/${clienteId}/listas`);
}
